import { Badge } from "@mui/material";
import React from "react";

const BulkActions = ({
  status,
  selected,
  BulkcustomerAttendances,
  BulkConfirmAppointments,
}) => {
  return (
    <>
      {status === "confirmed" ? (
        <>
          {selected && selected.length > 1 ? (
            <div className="my-auto" onClick={() => BulkcustomerAttendances()}>
              <Badge badgeContent={selected.length} color="primary">
                <span className="bg-blue-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer m-auto">
                  Bulk Mark Attendance
                </span>
              </Badge>
            </div>
          ) : (
            <div className="bg-gray-200 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-disabled my-auto">
              Bulk Mark Attendance
            </div>
          )}
        </>
      ) : (
        status !== "notAttended" && (
          <>
            {selected && selected.length > 1 ? (
              <div
                className="my-auto"
                onClick={() => BulkConfirmAppointments("confirm")}
              >
                <Badge badgeContent={selected.length} color="primary">
                  <span className="bg-blue-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer my-auto">
                    Bulk Confirm
                  </span>
                </Badge>
              </div>
            ) : (
              <div className="bg-gray-200 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-disabled my-auto">
                Bulk Confirm
              </div>
            )}
          </>
        )
      )}
    </>
  );
};

export default BulkActions;
